import {
  IconButton,
  Heading,
  Text,
  ActionDropdown,
  ShadowStyles,
  HStack,
} from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { sessionState } from '../../../../store/session/atom';
import { FeatureToggle, useUnleashFlags } from '../../../../utils/useUnleashFlags';
import { useHeader } from '../../hooks';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const { userProfile } = useRecoilValue(sessionState);
  const isManager = !!(userProfile?.isGestor && userProfile?.idTipoParceiro !== 4);
  const { b2bShowBasketRedemption } = useUnleashFlags(FeatureToggle.ShowBasketRedemption);

  const { handleGoBack, isMobile, handleCreateBatchTicketOrder, handleRedeemBatchTicketOrder } =
    useHeader();

  const iconSize = isMobile ? 'xxs' : 'xs';
  const iconColor = isMobile ? 'brand.primary.principal' : 'brand.tertiary.principal';
  const triggerColor = isMobile ? 'brand.tertiary.principal' : 'neutral.black';

  return (
    <HStack pt={Spacing['inset.lg']} alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          variant="link"
          {...(!isMobile && { shadow: 3 })}
          {...(isMobile && { p: 0, backgroundColor: 'transparent' })}
          onPress={handleGoBack}
          iconColor={Color[iconColor]}
          iconSize={iconSize}
        />
        {isMobile ? (
          <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Boleta em lote
          </Text>
        ) : (
          <Heading testId="qa" size="h2">
            Boleta em lote
          </Heading>
        )}
      </HStack>
      <ActionDropdown
        triggerLabel="NOVA BOLETA"
        triggerLabelColor={triggerColor}
        triggerIcon="Plus"
        triggerIconProps={{
          size: 'sm',
          color: Color[triggerColor],
        }}
        triggerIconReplacesDropdownIcon
        triggerProps={{
          backgroundColor: { sm: Color['neutral.white'] },
          borderRadius: { sm: 'full' },
          paddingLeft: { sm: Spacing['inset.sm'] },
          paddingRight: { sm: Spacing['inset.nano'] },
          style: isMobile ? undefined : ShadowStyles.Level[1],
          _text: {
            fontSize: { sm: Typography['fontsize.lg'] },
            fontWeight: { sm: Typography['fontweight.bold'] },
          },
        }}
        placement="bottom right">
        <ActionDropdown.Item label="APLICAR" icon="Apply" onPress={handleCreateBatchTicketOrder} />
        {isManager && b2bShowBasketRedemption && (
          <ActionDropdown.Item
            label="RESGATE"
            icon="Reclaim"
            onPress={handleRedeemBatchTicketOrder}
          />
        )}
      </ActionDropdown>
    </HStack>
  );
};
